<div class="ft-page">

  <!-- Header -->
  <div class="ft-header">
    <button type="button" class="ft-btn-back" (click)="goBack()">
      <i class="bx bx-left-arrow-circle"></i>
      INDIETRO
    </button>
    <h1 class="ft-title">Articolo "{{ artQr }}"</h1>
    <button type="button" class="ft-btn-report" (click)="openReport()">
      <i class="bx bxs-file-pdf"></i>
      REPORT
    </button>
  </div>

  <!-- Stage title -->
  <h2 class="ft-stage-title">{{ stageLabel(activeStage) }}</h2>

  @if (loading) {
    <div class="ft-loading">
      <div class="ft-spinner"></div>
      <p>Caricamento...</p>
    </div>
  }

  @if (!loading) {
    <div class="ft-body">

      <!-- ── Left timeline ── -->
      <div class="ft-timeline">
        @for (stage of stages; track stage; let i = $index) {
          <div class="ft-timeline__item">
            <!-- Node -->
            <div
              class="ft-timeline__node"
              [class.ft-timeline__node--active]="activeStage === stage"
              [class.ft-timeline__node--done]="activeStage > stage"
              (click)="setStage(stage)">
              <span class="ft-timeline__node-num">{{ i + 1 }})</span>
              <span class="ft-timeline__node-date">{{ stageDate(stage) }}</span>
            </div>
            <!-- Connector line -->
            @if (i < stages.length - 1) {
              <div class="ft-timeline__line"
                   [class.ft-timeline__line--active]="activeStage > stage"></div>
            }
          </div>
        }
      </div>

      <!-- ── Right cards panel ── -->
      <div class="ft-cards">

        <!-- Stage 1: Ordine al fornitore -->
        @if (activeStage === 1 && history?.supplier) {
          <div class="ft-arrow-row">
            <div class="ft-arrow"></div>
            <div class="ft-card">
              <div class="ft-card__icon"><i class="bx bxs-user-circle"></i></div>
              <div class="ft-card__body">
                <p class="ft-card__title">Ordine al fornitore</p>
                <p class="ft-card__sub">{{ history!.supplier!.name }}</p>
                <p class="ft-card__date">{{ formatDateTime(history!.supplier!.order_date) }}</p>
              </div>
            </div>
          </div>
        }

        <!-- Stage 2: Certificazioni fornitore -->
        @if (activeStage === 2 && history?.certification) {
          <!-- Row 1: cert card -->
          <div class="ft-arrow-row ft-arrow-row--stretch">
            <div class="ft-arrow"></div>
            <div class="ft-card ft-card--clickable"
                 [class.ft-card--selected]="selectedCard === 'cert'"
                 (click)="toggleCard('cert')">
              <div class="ft-card__icon"><i class="bx bxs-certification"></i></div>
              <div class="ft-card__body">
                <p class="ft-card__title">Certificazioni fornitore</p>
                <p class="ft-card__sub">N° {{ history!.certification!.files.length }} certificati</p>
                <p class="ft-card__date">{{ formatDateTime(history!.certification!.start_date) }}</p>
              </div>
              <i class="bx bx-chevron-right ft-card__chevron"></i>
            </div>
            @if (selectedCard === 'cert' && history!.certification!.files.length) {
              <div class="ft-cert-arrow"></div>
              <div class="ft-cert-panel">
                @if (certValidationSummary) {
                  <p class="ft-cert-panel__validation">
                    I certificati sono stati validati da
                    <strong>{{ certValidationSummary.certifier }}</strong>
                    {{ certValidationSummary.dateText }}
                  </p>
                }
                <p class="ft-cert-panel__title">Elenco certificati articolo</p>
                <div class="ft-cert-list">
                  @for (f of history!.certification!.files; track $index) {
                    <button type="button" class="ft-cert-item" (click)="openCertFile(f.document_url)">
                      <span>{{ f.document_description || 'certificato #' + ($index + 1) }}</span>
                      <i class="bx bxs-file-pdf ft-cert-item__pdf"></i>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
          <!-- Row 2: DDT card -->
          @if (history!.certification!.ddt_url) {
            <div class="ft-arrow-row ft-arrow-row--stretch">
              <div class="ft-arrow"></div>
              <div class="ft-card ft-card--clickable"
                   [class.ft-card--selected]="selectedCard === 'ddt'"
                   (click)="toggleCard('ddt')">
                <div class="ft-card__icon"><i class="bx bxs-file-doc"></i></div>
                <div class="ft-card__body">
                  <p class="ft-card__title">DDT fornitore</p>
                  <p class="ft-card__sub">Chiusura ordine fornitore</p>
                  <p class="ft-card__date">{{ formatDateTime(history!.certification!.closing_date) }}</p>
                </div>
                <i class="bx bx-chevron-right ft-card__chevron"></i>
              </div>
              @if (selectedCard === 'ddt') {
                <div class="ft-cert-arrow"></div>
                <div class="ft-cert-panel ft-cert-panel--pdf">
                  <p class="ft-cert-panel__title">DDT</p>
                  <iframe
                    class="ft-cert-pdf"
                    [src]="ddtSafeUrl"
                  ></iframe>
                </div>
              }
            </div>
          }
        }

        <!-- Stage 3: Carico in magazzino -->
        @if (activeStage === 3 && history?.warehouse) {
          <!-- Arrivo ordine fornitore (no panel) -->
          <div class="ft-arrow-row">
            <div class="ft-arrow"></div>
            <div class="ft-card">
              <div class="ft-card__icon"><i class="bx bxs-package"></i></div>
              <div class="ft-card__body">
                <p class="ft-card__title">Arrivo ordine fornitore</p>
                <p class="ft-card__sub">{{ history!.warehouse!.operator }}</p>
                <p class="ft-card__date">{{ formatDateTime(history!.warehouse!.start_date) }}</p>
              </div>
            </div>
          </div>
          <!-- Controllo Qualità → panel -->
          @if (history!.warehouse!.qc_date) {
            <div class="ft-arrow-row ft-arrow-row--stretch">
              <div class="ft-arrow"></div>
              <div class="ft-card ft-card--clickable"
                   [class.ft-card--selected]="selectedCard === 'wh-qc'"
                   (click)="toggleCard('wh-qc')">
                <div class="ft-card__icon"><i class="bx bxs-shield-alt-2"></i></div>
                <div class="ft-card__body">
                  <p class="ft-card__title">Controllo Qualità</p>
                  <p class="ft-card__sub">Richiesto: SI/NO</p>
                  <p class="ft-card__date">{{ formatDateTime(history!.warehouse!.qc_date) }}</p>
                </div>
                <i class="bx bx-chevron-right ft-card__chevron"></i>
              </div>
              @if (selectedCard === 'wh-qc') {
                <div class="ft-cert-arrow"></div>
                <div class="ft-cert-panel">
                  <p class="ft-cert-panel__title">Controllo Qualità</p>
                  <div class="ft-info-list">
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">Operatore:</span>
                      <span class="ft-info-row__value">Quality Opertor</span>
                      <!--<span class="ft-info-row__value">{{ history!.warehouse!.operator || '-' }}</span>-->
                    </div>
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">Risultato:</span>
                      <span class="ft-info-row__value">{{ history!.warehouse!.qc_result || '-' }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          <!-- Carico magazzino (no panel) -->
          @if (history!.warehouse!.closing_date) {
            <div class="ft-arrow-row">
              <div class="ft-arrow"></div>
              <div class="ft-card">
                <div class="ft-card__icon"><i class="bx bxs-store"></i></div>
                <div class="ft-card__body">
                  <p class="ft-card__title">Carico magazzino</p>
                  <p class="ft-card__sub">{{ history!.warehouse!.operator }}</p>
                  <p class="ft-card__date">{{ formatDateTime(history!.warehouse!.closing_date) }}</p>
                </div>
              </div>
            </div>
          }
        }

        <!-- Stage 4: Preparazione ordine -->
        @if (activeStage === 4 && history?.expedition) {
          <!-- Raccolta prodotti → Dettagli prodotto panel -->
          <div class="ft-arrow-row ft-arrow-row--stretch">
            <div class="ft-arrow"></div>
            <div class="ft-card ft-card--clickable"
                 [class.ft-card--selected]="selectedCard === 'exp-raccolta'"
                 (click)="toggleCard('exp-raccolta')">
              <div class="ft-card__icon"><i class="bx bxs-shopping-bag"></i></div>
              <div class="ft-card__body">
                <p class="ft-card__title">Raccolta prodotti</p>
                <p class="ft-card__sub">Operatore: {{ history!.expedition!.operator }}</p>
                <p class="ft-card__date">{{ formatDateTime(history!.expedition!.start_date) }}</p>
              </div>
              <i class="bx bx-chevron-right ft-card__chevron"></i>
            </div>
            @if (selectedCard === 'exp-raccolta') {
              <div class="ft-cert-arrow"></div>
              <div class="ft-cert-panel">
                <p class="ft-cert-panel__title">Dettagli prodotto</p>
                <div class="ft-info-list">
                  <div class="ft-info-row">
                    <span class="ft-info-row__label">Codice prodotto:</span>
                    <span class="ft-info-row__value">{{ history!.expedition!.product_code || '-' }}</span>
                  </div>
                  <div class="ft-info-row">
                    <span class="ft-info-row__label">Descrizione prodotto:</span>
                    <span class="ft-info-row__value">{{ history!.expedition!.product_description || '-' }}</span>
                  </div>
                  <div class="ft-info-row">
                    <span class="ft-info-row__label">Categoria:</span>
                    <span class="ft-info-row__value">{{ history!.expedition!.category || '-' }}</span>
                  </div>
                  <div class="ft-info-row">
                    <span class="ft-info-row__label">Corsia:</span>
                    <span class="ft-info-row__value">{{ history!.expedition!.aisle ?? '-' }}</span>
                  </div>
                  <div class="ft-info-row">
                    <span class="ft-info-row__label">Scaffale:</span>
                    <span class="ft-info-row__value">{{ history!.expedition!.shelf ?? '-' }}</span>
                  </div>
                  <div class="ft-info-row">
                    <span class="ft-info-row__label">Ripiano:</span>
                    <span class="ft-info-row__value">{{ history!.expedition!.ledge ?? '-' }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
          <!-- DOP (wip) → opens PDF -->
          <div class="ft-arrow-row ft-arrow-row--stretch">
            <div class="ft-arrow"></div>
            <div class="ft-card ft-card--wip ft-card--clickable"
                 [class.ft-card--selected]="selectedCard === 'exp-dop'"
                 (click)="history!.expedition!.dop_url ? toggleCard('exp-dop') : null">
              <div class="ft-card__icon"><i class="bx bxs-file"></i></div>
              <div class="ft-card__body">
                <p class="ft-card__title">DOP (wip)</p>
                <p class="ft-card__sub">Operatore: {{ history!.expedition!.operator }}</p>
                <p class="ft-card__date">{{ formatDateTime(history!.expedition!.dop_date) }}</p>
              </div>
              @if (history!.expedition!.dop_url) {
                <i class="bx bx-chevron-right ft-card__chevron"></i>
              }
            </div>
            @if (selectedCard === 'exp-dop' && history!.expedition!.dop_url) {
              <div class="ft-cert-arrow"></div>
              <div class="ft-cert-panel">
                <p class="ft-cert-panel__title">DOP</p>
                <div class="ft-cert-list">
                  <button type="button" class="ft-cert-item" (click)="openCertFile(history!.expedition!.dop_url!)">
                    <span>DOP</span>
                    <i class="bx bxs-file-pdf ft-cert-item__pdf"></i>
                  </button>
                </div>
              </div>
            }
          </div>
          <!-- Imballaggio → Collo panel -->
          @if (history!.expedition!.box_type) {
            <div class="ft-arrow-row ft-arrow-row--stretch">
              <div class="ft-arrow"></div>
              <div class="ft-card ft-card--clickable"
                   [class.ft-card--selected]="selectedCard === 'exp-box'"
                   (click)="toggleCard('exp-box')">
                <div class="ft-card__icon"><i class="bx bxs-dropbox"></i></div>
                <div class="ft-card__body">
                  <p class="ft-card__title">Imballaggio</p>
                  <p class="ft-card__sub">Operatore: {{ history!.expedition!.operator }}</p>
                  <p class="ft-card__date">{{ formatDateTime(history!.expedition!.box_start_date) }}</p>
                </div>
                <i class="bx bx-chevron-right ft-card__chevron"></i>
              </div>
              @if (selectedCard === 'exp-box') {
                <div class="ft-cert-arrow"></div>
                <div class="ft-cert-panel">
                  <p class="ft-cert-panel__title">Collo</p>
                  <div class="ft-cert-list">
                    <button type="button" class="ft-cert-item">
                      <span>{{ history!.expedition!.box_type }} #{{ history!.expedition!.box_number }}</span>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          <!-- Dettagli Spedizione → shipping details panel -->
          @if (history!.expedition!.expedition_date) {
            <div class="ft-arrow-row ft-arrow-row--stretch">
              <div class="ft-arrow"></div>
              <div class="ft-card ft-card--clickable"
                   [class.ft-card--selected]="selectedCard === 'exp-ship'"
                   (click)="toggleCard('exp-ship')">
                <div class="ft-card__icon"><i class="bx bxs-map-pin"></i></div>
                <div class="ft-card__body">
                  <p class="ft-card__title">Dettagli Spedizione</p>
                  <p class="ft-card__sub">Operatore: {{ history!.expedition!.operator }}</p>
                  <p class="ft-card__date">{{ formatDateTime(history!.expedition!.expedition_date) }}</p>
                </div>
                <i class="bx bx-chevron-right ft-card__chevron"></i>
              </div>
              @if (selectedCard === 'exp-ship') {
                <div class="ft-cert-arrow"></div>
                <div class="ft-cert-panel">
                  <p class="ft-cert-panel__title">Dettagli spedizione</p>
                  <div class="ft-info-list">
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">Corriere:</span>
                      <span class="ft-info-row__value">{{ history!.expedition!.courier || '-' }}</span>
                    </div>
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">Indirizzo:</span>
                      <span class="ft-info-row__value">{{ history!.expedition!.address || '-' }}</span>
                    </div>
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">Città:</span>
                      <span class="ft-info-row__value">{{ history!.expedition!.city || '-' }}</span>
                    </div>
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">Provincia:</span>
                      <span class="ft-info-row__value">{{ history!.expedition!.prov || '-' }}</span>
                    </div>
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">CAP:</span>
                      <span class="ft-info-row__value">{{ history!.expedition!.CAP || '-' }}</span>
                    </div>
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">Nazione:</span>
                      <span class="ft-info-row__value">{{ history!.expedition!.state || '-' }}</span>
                    </div>
                    <div class="ft-info-row">
                      <span class="ft-info-row__label">Note:</span>
                      <span class="ft-info-row__value">{{ history!.expedition!.note || '-' }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        }

        <!-- Stage 5: Status spedizione -->
        @if (activeStage === 5 && history?.tracking) {
          @for (event of history!.tracking!.events; track $index) {
            <div class="ft-arrow-row">
              <div class="ft-arrow"></div>
              <div class="ft-card" [class.ft-card--highlight]="$last">
                <div class="ft-card__icon"><i class="bx bx-list-ul"></i></div>
                <div class="ft-card__body">
                  <p class="ft-card__title" [class.ft-card__title--green]="$last">{{ event.status }}</p>
                  <p class="ft-card__sub">{{ event.location }}</p>
                  <p class="ft-card__date">{{ formatDateTime(event.date) }}</p>
                </div>
              </div>
            </div>
          }
          @if (!history!.tracking!.events?.length) {
            <p class="ft-no-data">Nessun dato di tracking disponibile.</p>
          }
        }

        @if (!history) {
          <p class="ft-no-data">Nessun dato disponibile.</p>
        }

      </div>
    </div>
  }

</div>
